import '../../../../scss/pdf-editor.scss';
import '../../../../scss/critical.scss';

import { globalLogger } from '../../../qaamgo/helper/global-logger';

if (global.MODULE_LOADED_EDIT_PDF) {
    globalLogger.log('double import');
} else {
    global.MODULE_LOADED_EDIT_PDF = true;

    const $ = require('jquery');
    global.$ = global.jQuery = $;

    import(
        /* webpackMode: "eager" */
        '../../qg-main'
    ).then(function () {
        window.qgOperation = 'edit';
        import('../../../qaamgo/modules/sat/pdfeditor/pdf-editor').then(function () {
            window.jobId = window.qgQueryFragmentHelper.getValueFromCurrentUrl('j');
            qgPdfEditor.init({ jobId: window.jobId });

            $(document).on('click', 'button.menu-toggle', function () {
                // each menu button has a target class...
                var target = $(this).attr('data-target');

                const RESPONSIVE_HIDDEN_CLASSES = 'hidden-xs hidden-md hidden-sm';
                const ALL_HIDDEN_CLASSES = 'hidden-xs hidden-md hidden-sm hidden';

                // we iterate over every menu-left to find the targeted menu
                $('.menu-left').each(function (index) {
                    const isTargetedMenu = $(this).hasClass(target);

                    // the menus which are not the target are set to hidden
                    if (!isTargetedMenu) {
                        $(this).addClass(ALL_HIDDEN_CLASSES);

                        return;
                    }

                    const isInvisible = !$(this).is(':visible');
                    const hasHiddenClass = $(this).hasClass('hidden');

                    // T4564 This handles a special case
                    // By default the panel for thumbnails is shown after loading (they don't have 'hidden'
                    // class in their template. but due to the hidden-X classes it still might be hidden in
                    // narrow browser.
                    //
                    // when the user then clicks the button for the first time the panel is not visible when the default
                    // show/hide logic is used. therefore we add some new logic for this specific case
                    if (isInvisible && !hasHiddenClass) {
                        $(this).removeClass(RESPONSIVE_HIDDEN_CLASSES);

                        return;
                    }

                    if (hasHiddenClass) {
                        $(this).removeClass(ALL_HIDDEN_CLASSES);
                    } else {
                        $(this).addClass(ALL_HIDDEN_CLASSES);
                    }
                });

                $('.menu-right').each(function (index) {
                    if (!$(this).hasClass(target)) {
                        $(this).addClass('hidden-xs').addClass('hidden-md').addClass('hidden-sm').addClass('hidden');
                    }
                    if ($(this).hasClass(target)) {
                        if ($(this).hasClass('hidden')) {
                            $(this)
                                .removeClass('hidden-xs')
                                .removeClass('hidden-md')
                                .removeClass('hidden-sm')
                                .removeClass('hidden');
                        } else {
                            $(this)
                                .addClass('hidden-xs')
                                .addClass('hidden-md')
                                .addClass('hidden-sm')
                                .addClass('hidden');
                        }
                    }
                });
            });
        });
    });
}
